import React from "react";
import styles from "./Destinations9.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations9 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  // Duplicate array for seamless scrolling
  const scrollItems = [...destinations, ...destinations];

  return (
    <section className={styles.section}>
      <div className={styles.gridOverlay}></div>

      <div className={styles.header}>
        <div className={styles.scanner}></div>
        <h2 className={styles.title}>
          System.<span>Locate</span>
        </h2>
        <p className={styles.lead}>
          Scanning global coordinates for optimal transit
        </p>
      </div>

      <div className={styles.wrapper}>
        <div className={styles.track}>
          {scrollItems.map((dest, index) => {

            const fallbackImage =
              fallbackImages[index % fallbackImages.length];

            const imageUrl =
              dest?.image && dest.image.trim() !== ""
                ? dest.image
                : fallbackImage;

            return (
              <div key={index} className={styles.card}>
                <div className={styles.frame}>

                  {/* Corner Brackets */}
                  <span className={`${styles.bracket} ${styles.tl}`}></span>
                  <span className={`${styles.bracket} ${styles.tr}`}></span>
                  <span className={`${styles.bracket} ${styles.bl}`}></span>
                  <span className={`${styles.bracket} ${styles.br}`}></span>

                  <div className={styles.imageWrapper}>
                    <img
                      src={imageUrl}
                      alt={dest?.name || "Destination"}
                      className={styles.image}
                      onError={(e) => {
                        e.target.src = fallbackImage;
                      }}
                    />

                    <div className={styles.scanBar}></div>
                  </div>
                </div>

                <div className={styles.info}>
                  <div className={styles.meta}>
                    <span className={styles.coord}>
                      LOC: {index + 10}8.22 / NW
                    </span>

                    <span className={styles.status}>
                      ACTIVE
                    </span>
                  </div>

                  <h3 className={styles.cardTitle}>
                    {dest?.name || "Explore Destination"}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Destinations9;